// extracted by mini-css-extract-plugin
module.exports = {"menu":"YNsVo21s","menubox":"PllIBKkB","adPlaceholder":"a3Ev_7qi","withAd":"kif7c3mA"};